import { defineMessages } from 'react-intl'

export default defineMessages({
    "error": {
        "defaultMessage": "Error",
        "id": "src.common.elements.errorMessage.title"
    },
    "ok": {
        "defaultMessage": "OK",
        "id": "src.common.elements.ok.button"
    },
    "service": {
        "defaultMessage": "Service",
        "id": "src.common.elements.service"
    }
})

